import { StatusMessageType } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Button from '../../components/Button';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  message: string;
  messageType?: StatusMessageType;
  goBack: () => void;
  shouldShowSeeMembershipPlansButton: boolean;
  seeMembershipPlans: () => void;
  t: (key: string) => string;
}

export const SubscriptionScreenStatusMessage: FunctionComponent<IProps> = (
  {
    message,
    messageType,
    goBack,
    t,
    shouldShowSeeMembershipPlansButton,
    seeMembershipPlans,
  },
) => {
  const messageContent = () => {
    switch (messageType) {
      case 'info':
        return (
          <View>
            <Text style={styles.header}>{t('statusHeaderInfo')}:</Text>
            <Text style={styles.body}>{decodeURI(message)}</Text>
          </View>
        );
      default:
        return (
          <View>
            <Text style={styles.header}>{t('statusHeaderError')}:</Text>
            <Text style={styles.body}>{decodeURI(message)}</Text>
          </View>
        );
    }
  };

  return (
    <View style={styles.container}>
      {messageContent()}
      {shouldShowSeeMembershipPlansButton &&
        <Button
          fontColor={Theme.WHITE}
          title={t('backToMembershipPlans')}
          onPress={seeMembershipPlans}
          containerStyle={{ marginTop: defaultScale(20) }}
        />
      }

      {!shouldShowSeeMembershipPlansButton &&
        <Button
          fontColor={Theme.WHITE}
          title={t('subscriptionErrorMessageButton')}
          onPress={goBack}
          containerStyle={{ marginTop: defaultScale(20) }}
        />
      }
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: defaultScale(15),
    paddingTop: defaultScale(40),
    backgroundColor: Theme.WHITE,
    flex: 1,
  },
  header: {
    ...Theme.textStyle.heading,
  },
  body: {
    ...Theme.textStyle.bodyCopyReg,
  },
  error: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.RED,
  },
});
